import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15 })

    this.element.querySelectorAll("[data-animate]").forEach((el, i) => {
      el.style.setProperty("--i", i)
      this.observer.observe(el)
    })
  }

  disconnect() {
    this.observer.disconnect()
  }
}
